import { render, staticRenderFns } from "./DuaMessageTripCard.vue?vue&type=template&id=3955e02d"
import script from "./DuaMessageTripCard.vue?vue&type=script&lang=js"
export * from "./DuaMessageTripCard.vue?vue&type=script&lang=js"
import style0 from "./DuaMessageTripCard.vue?vue&type=style&index=0&id=3955e02d&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports